import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export interface RetentionPoint {
  /** Seconds from the start of a play. */
  seconds: number;
  /** Share of viewers still watching, in percent. */
  watchPct: number;
}

interface RetentionCurveChartProps {
  points: RetentionPoint[];
  /** Pin the x-axis to the video length; defaults to the data range. */
  durationSeconds?: number | null;
  emptyLabel: string;
  height?: number;
}

/**
 * Audience retention curve (seconds → % still watching). Shared by the
 * YouTube deep dive and the piece drawer (Facebook Reels). Values can
 * legitimately exceed 100% (rewinds/looping) — never clamp them.
 */
export function RetentionCurveChart({
  points,
  durationSeconds,
  emptyLabel,
  height = 220,
}: RetentionCurveChartProps) {
  if (points.length === 0) {
    return <div className="py-6 text-center text-sm text-muted-foreground">{emptyLabel}</div>;
  }
  const domain: [number, number | "dataMax"] =
    durationSeconds && durationSeconds > 0 ? [0, durationSeconds] : [0, "dataMax"];
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={points}>
        <XAxis dataKey="seconds" fontSize={10} type="number" domain={domain} unit="s" />
        <YAxis fontSize={10} unit="%" />
        <Tooltip />
        <Area type="monotone" dataKey="watchPct" stroke="#10b981" fill="#10b98133" />
      </AreaChart>
    </ResponsiveContainer>
  );
}
